import DiaLog from '../../../../../components/Dialog';
import { i18n } from '../../../../../language';

const ResetDialog = ({ dialogFinishHandler, dialogCloseHandler }) => {
  return (
    <DiaLog
      open={true}
      handleClose={dialogCloseHandler}
      handleCancel={dialogCloseHandler}
      handleConfirm={dialogFinishHandler}
      title={i18n.t('SETTING_RESET_IP_ADDRESS')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      dialogfootStyle={{ marginTop: '1rem' }}
    >
      {/* <Box>
        {i18n.t('SETTING_RESET_IP_ADDRESS')}
      </Box> */}
    </DiaLog>
  );
};
export default ResetDialog;
